import React from "react";
import Head from "next/head";
import { NextSeo } from "next-seo";
import { seoFunct } from "../../config/next-seo.config.js";
import { withRouter } from "next/router";
import HomeNav from "../Home/HomeNav.jsx";
import HomeFooter from "../Home/HomeFooter.jsx";
import HighlightCard from "../../revampComponents/HighlightCard.js";
import FeaturesCard from "../../revampComponents/FeaturesCard.js";
import revampData from "../../data/revampData.json";
import { reorderByOrderNo } from "../../config/constants.js";
const ExhibitorPortal = () => {
  const ExhibitorPortalHighlight = revampData.data.listExhibitorPortalHighlight.data;
  const ExhibitorPortalFeatures = revampData.data.listExhibitorPortalFeatureCard.data;
  const reorderedData = reorderByOrderNo(ExhibitorPortalFeatures);
  return <div className="font-figtree" data-sentry-component="ExhibitorPortal" data-sentry-source-file="ExhibitorPortal.jsx">
            <HomeNav data-sentry-element="HomeNav" data-sentry-source-file="ExhibitorPortal.jsx" />
            <HighlightCard data={ExhibitorPortalHighlight} data-sentry-element="HighlightCard" data-sentry-source-file="ExhibitorPortal.jsx" />
            <FeaturesCard featuresData={reorderedData} data-sentry-element="FeaturesCard" data-sentry-source-file="ExhibitorPortal.jsx" />
            <HomeFooter data-sentry-element="HomeFooter" data-sentry-source-file="ExhibitorPortal.jsx" />

            <style jsx>{`
                .main-container {
                    width: 100%;
                }
            `}</style>
        </div>;
};
export default withRouter(ExhibitorPortal);